import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";
import moment from "moment";

import templateContent from "./set-cca-modal.html";

import { applicatorTeamComponent } from "../../components/applicatorTeamComponent";
import followUpManager from "../../_shark_jaws/managers/followUpManager";
import { clientManager } from "../../_shark_jaws/managers/clientManager";
import { constructionSiteCardManager } from "../../_shark_jaws/managers/constructionSiteCardManager";
import { documentManager } from "../../_shark_jaws/managers/documentManager";
import { informationModalComponent } from "../../components/informationModal/informationModalComponent";
import { quotationManager } from "../../_shark_jaws/managers/quotationManager";
import { siteInfoSheetManager } from "../../_shark_jaws/managers/siteInfoSheetManager";
import teamUpManager from "../../_shark_jaws/managers/teamUpManager";
import { userManager } from "../../_shark_jaws/managers/userManager";
import { visitManager } from "../../_shark_jaws/managers/visitManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";
import ccaDetailsManager from "../../controllers/ccaDetailsManager";
import { notComplianceReportManager } from "../../_shark_jaws/managers/notComplianceReportManager";

class SetCCAModalComponent extends Component {
	constructor () {
		super("setCCAModalComponent");

		this.addTemplate("", templateContent);
	}

	afterRender () {
		if (this.get("open")) {
			this.open();
		}
	}

	close () {
		Shark.set({
			currNotComplianceReport: null
		});

		this.set({
			open: false,
		});
		$(`#setCCAModal`).modal("hide");
	}

	
	init () {
		this.addComponents([/*applicatorTeamComponent,*/informationModalComponent, waitBoxComponent]);
	}

	open () {
		Shark.render();
		$(`#setCCAModal`).modal("show");
		this.set({
			open: true,
		});
	}

	setCCAModalConfirmCCABtn_clickHandler () {
		waitBoxComponent.open();
		const currNotComplianceReport = Shark.get("currNotComplianceReport");
		
		if (currNotComplianceReport) {
			let extraDates;
			let ccaToSearch = currNotComplianceReport.cca;
	
			teamUpManager.getEventListByCCA(ccaToSearch, currNotComplianceReport.__teamUpId)
			.then(getEventListByCCAResponse => {
				const ccaEventList = getEventListByCCAResponse.data;

				console.log({getEventListByCCAResponse})

				if (getEventListByCCAResponse.currCCADetails) {
					//Dave: ok, ora il giro del CCADetails funziona, ma ne viene creato uno nuovo ogni volta, dovrei staticizzare la cosa facendo in modo che ad ogni save controllo se esiste già una CCA nel DB e la aggiorno
					const currCCADetails = getEventListByCCAResponse.currCCADetails;

					ccaDetailsManager.save(currCCADetails)
					.then(saveResponse => {
						console.log({currCCADetails, saveResponse});

						let newStatus = currNotComplianceReport.status;
						let statusMessage = "";

						if (currNotComplianceReport.status === 4 && currNotComplianceReport.extraData.constructionSiteWorksheetDocumentGuid !== "") {
							newStatus = 5;
							statusMessage = "Il Cantiere relativo è ora pronto a partire.";
						}
						else if (currNotComplianceReport.status === 1 && currNotComplianceReport.extraData.constructionSiteWorksheetDocumentGuid === "") {
							newStatus = 4;
							statusMessage = "Il Rapporto di non Conformità è ora in attesa del Foglio Lavoro Cantiere.";
						}
						
						currNotComplianceReport.set({
							cca: currCCADetails.cca,
							ccaDetailsGuid: currCCADetails.guid,
							status: newStatus,
						});

						notComplianceReportManager.save(currNotComplianceReport)
						.then(saveNCRResponse => {
							console.log({saveNCRResponse});

							const newFollowUp = Shark.getInstance("ClientFollowUp", {
								body: `Impostata la CCA <strong>${currCCADetails.cca}</strong> per il Rapporto di non Conformità <strong>${currNotComplianceReport.__numberLabel}</strong>.${statusMessage ? " " + statusMessage : ""}`,
								clientGuid: currNotComplianceReport.clientGuid,
								referenceGuid: currNotComplianceReport.guid,
								referenceType: "notComplianceReport",
								status: 3,
								type: "system"
							});

							followUpManager.save(newFollowUp)
							.then(followUpSaveResponse => {
								waitBoxComponent.hide();
								this.close();
								if (typeof Shark.activePage.refreshList === "function") {
									Shark.activePage.refreshList();
								}
								else {
									Shark.render();
								}
							});
						});
					});
				}
				else {
					waitBoxComponent.close();
					informationModalComponent.show({body: "Attenzione, la CCA inserita non corrisponde a nessun evento sul calendario TeamUp.<br><br>Per favore prima di procere crea l'evento su TeamUp.", title: "Informazione"});
				}
			});
		}
	}

	setCCABtn_clickHandler (event, data) {
		//Dave: Sarebbe carino usare questo componente anche per preventivi e CSC, così è sempre uguale.. ovviamente dovrà capire dove cercare.
		const currNotComplianceReport = Utils.safp(Shark.get("notComplianceReportList"), "guid", data.guid);

		if (currNotComplianceReport.cca.trim() !== "") {
			if (!confirm("Sei sicuro di voler modificare la CCA di questo Rapporto di non Conformità anche se è già impostata?")) {
				return;
			}
		}

		Shark.set({
			currNotComplianceReport
		});

		this.open();
	}

	setCCAModalCancelBtn_clickHandler (event, data) {
		const currNotComplianceReport = Shark.get("currNotComplianceReport");
		currNotComplianceReport.restore();

		this.close();
	}
}

const setCCAModalComponent = new SetCCAModalComponent();

Shark.registerComponent(setCCAModalComponent);

export default setCCAModalComponent;
